// extracted by mini-css-extract-plugin
module.exports = {"minmax_wrapper":"style_minmax_wrapper__3Q7cd"};